import React from 'react';
import styled from 'styled-components';

import { H3, Text } from '../../atoms';
import { ReactComponent as LogoMobile } from '../../../assets/images/logo-mobile.svg';

const MobileBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  height: 100vh;
`;

const StyledH3 = styled(H3)`
  margin-bottom: 8px;
  margin-top: 12px;
`;

const MobileBanner = () => (
  <MobileBannerContainer>
    <LogoMobile />
    <StyledH3>Hold Tight!</StyledH3>
    <Text $color='var(--content-subtitle)'>We’re not quite ready for mobile yet.</Text>
    <Text $color='var(--content-subtitle)'>Visit us on your desktop to explore further.</Text>
  </MobileBannerContainer>
);

export { MobileBanner };
